export type Tab = 'MINE' | 'ALL' | 'NEEDS_ADMIN' | 'RESOLVED';

interface Props {
  tab: Tab;
  isAdmin: boolean;
  counts: { MINE: number; ALL: number; NEEDS_ADMIN: number; RESOLVED: number };
  onChange: (next: Tab) => void;
}

function labelFor(tab: Tab): string {
  switch (tab) {
    case 'MINE':
      return 'My queue';
    case 'ALL':
      return 'All';
    case 'NEEDS_ADMIN':
      return 'Needs admin';
    case 'RESOLVED':
      return 'Resolved';
  }
}

export default function QueueTabs({ tab, isAdmin, counts, onChange }: Props) {
  const visible: Tab[] = isAdmin
    ? ['MINE', 'ALL', 'NEEDS_ADMIN', 'RESOLVED']
    : ['MINE'];

  return (
    <div className="Moderation__Tabs" role="tablist" aria-label="Queue tabs">
      {visible.map((t) => (
        <button
          key={t}
          type="button"
          role="tab"
          aria-selected={tab === t}
          className={`Moderation__Tab${tab === t ? ' is-active' : ''}${
            t === 'NEEDS_ADMIN' ? ' Moderation__Tab--admin' : ''
          }`}
          onClick={() => onChange(t)}
        >
          {labelFor(t)} ({counts[t]})
        </button>
      ))}
    </div>
  );
}
